/**
* convert the array of tags to string
* @param {Array} resource_tags
*/
export const spliceTags = (resource_tags) => {
    return resource_tags.map(resource_tag => resource_tag.tag).toString();
}
